import { useEffect, useState} from "react";
import ApiServices from "../../config/ApiServices";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader, showLoader } from "../../redux/actions/LoaderActions";
import Loader from "../../utils/Loader";
import * as qs from "qs"
import { Link, useParams } from "react-router-dom";
import { showModal } from "../../redux/actions/ModalActions";

export default function AdminBatches({title}){
   const dispatch=useDispatch()
   const loading=useSelector((state)=>state.loader.loading)
   const [status,setStatus]=useState(true)   // true = Current, false = Archive
   const [batches,setBatches]=useState([])
   const {trainerId, studentId}=useParams()
   const isOpen = useSelector((state) => state.modal.isOpen);

   useEffect(()=>{
    if(!isOpen){
      dispatch(showLoader())
      let data={status:status}
      if(!!trainerId){
          data.trainerId=trainerId
      }
      if(!!studentId){
          data.studentId=studentId
      }
      ApiServices.apiRequest("getBatch",data)
      .then((result)=>{
          if(result.data.success){
              setBatches(result.data.data)
              console.log(result.data.data)
          }else{
              toast.error(result.data.message)
          }
      })
      .catch((err)=>{
          toast.error(err?.message?err?.message:"Something went wrong!!");
      })
      .finally(()=>{
          dispatch(hideLoader())
      })
    }
   },[trainerId, studentId, isOpen, status])   

    return(
        <>
            <div className="container">
                <div className="page-inner">
                {
                    loading? 
                    <Loader/>
                    :
                    <>
                        <div className="d-flex align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
                            <div>
                            <h3 className="fw-bold mb-3">{title}</h3>
                            <select 
                                className="form-select" 
                                onChange={(e)=>{setStatus(e.target.value === "true")}}   
                                value={status}
                            >
                                <option value={true}>Current</option>
                                <option value={false}>Archive</option>
                            </select>
                            </div>
                            <div className="ms-md-auto py-2 py-md-0">
                                <button 
                                    onClick={()=>{dispatch(showModal("AddBatch"))}} 
                                    className="btn btn-primary btn-round"
                                >
                                    Create Batch
                                </button>
                            </div>
                        </div>
                        <div className="container">
                            <div className="row">
                                {
                                    batches?.length>0?
                                    batches?.map((el,index)=>(
                                        <div className="col-sm-6 text-capitalize col-md-4 col-12" key={index}>
                                            <Link to={"/admin/viewBatches/"+el?._id}>
                                                <div className="card p-3">
                                                    <h4 
                                                      className="text-nowrap my-0" 
                                                      style={{textOverflow:"ellipsis", overflow:"hidden"}}
                                                    >
                                                      {el?.name} 
                                                    </h4>
                                                    <div> ({el?.batchTime})</div>
                                                    <div>{el?.ownerId?.name}</div>
                                                </div>
                                            </Link>
                                        </div>
                                    ))
                                    :
                                    <h1>No Batch Found!!</h1>
                                }
                            </div>
                        </div>
                    </>
                }
                </div>
            </div>
        </>
    )
}
